import { sumElementMultipliers } from "../sumElementMultipliers";
import type { BulkRemovePlanElements } from "./types";

export const bulkRemovePlanElements: BulkRemovePlanElements = ({
  plan,
  elementIds,
}) => {
  const idsToRemove = new Set(elementIds);
  const byGroupId = { ...plan.groupedElements.byGroupId };
  const emptiedGroupLabels = new Set<string>();
  let removedAnything = false;
  let removedQuantity = 0;

  for (const groupLabel of Object.keys(byGroupId)) {
    const groupElements = byGroupId[groupLabel];
    const remainingElements = groupElements.filter(
      (element) => !idsToRemove.has(element.id),
    );

    if (remainingElements.length === groupElements.length) {
      continue;
    }

    removedAnything = true;
    removedQuantity += sumElementMultipliers({
      elements: groupElements.filter((element) => idsToRemove.has(element.id)),
    });
    if (remainingElements.length === 0) {
      emptiedGroupLabels.add(groupLabel);
      delete byGroupId[groupLabel];
    } else {
      byGroupId[groupLabel] = remainingElements;
    }
  }

  if (!removedAnything) {
    return plan;
  }

  const groupIds = plan.groupedElements.groupIds.filter(
    (groupLabel) => !emptiedGroupLabels.has(groupLabel),
  );

  let groupMeta = plan.groupMeta;
  if (emptiedGroupLabels.size > 0) {
    groupMeta = { ...plan.groupMeta };
    for (const emptiedGroupLabel of emptiedGroupLabels) {
      delete groupMeta[emptiedGroupLabel];
    }
  }

  return {
    ...plan,
    groupedElements: {
      ...plan.groupedElements,
      byGroupId,
      groupIds,
      all: {
        ...plan.groupedElements.all,
        count: Math.max(0, plan.groupedElements.all.count - removedQuantity),
      },
    },
    groupMeta,
  };
};
